import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import type { AlertProps } from "@mui/material/Alert";

interface CalloutProps extends AlertProps {
  title?: string;
}

export function Callout({
  severity = "info",
  variant = "outlined",
  title,
  children,
  ...props
}: CalloutProps) {
  return (
    <Alert severity={severity} variant={variant} {...props}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </Alert>
  );
}
